import React, { useEffect, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { SVGPureIcon } from '@/ui';
import store from './store';
import urlStore from '@/store/chat/urlStore';
import navbarStore from '@/store/navbar';
import { useParams } from 'react-router-dom';
import { isAgentFlowId, McpServerInstallStatus } from '@shared/constants/mcp';
import ChatInput from '@/components/chat/ChatInput';
import InviteCodeModal from '@src/components/modal/invite-code';
import homeStore from '../home/store';
import ScrollView from '@/ui/scroll-view';
import './index.scss';
import inputTypeStore from '@/components/input-file/input-type';
import SayList from './components/SayList';
import userStore from '@/store/user';
import globalStore from '@/store/global';
import AagentMenu from '../agent-home/components/agent-menu';
import Conf from '@/common/conf';
import Prompts from '../chat/components/prompts'; // 智能体表单组件
import AgentShare from '../agent-home/components/agent-share';
import PromptExample from './components/PromptExample';
import copy from 'copy-to-clipboard';
import Other from '@/common/helper/other';
import client from '@/store/client';
import appLogger from '@public/log/monitor';
import { HelperCore } from '@/common/dependencies';
import VipTag from '@/components/agent-limit/vip-tag';

function ChatAgent() {
  const { sayList, serverList, agentInfo, installed } = store;
  const { saylist_example } = agentInfo;
  const params = useParams();
  const sugList = homeStore.sugList;

  const getPlaceholder = useMemo(() => {
    return agentInfo?.input_tip || agentInfo?.input_tip_defalt || ''
  }, [ agentInfo ]);

  React.useEffect(() => {
    // 获取路径参数的 agentId
    return () => {
      store.reset();
    };
  }, []);

  React.useEffect(() => {
    if (!params?.agentId) return;
    store.reset();
    store.initAgentInfo(params.agentId);
  }, [params?.agentId]);

  // 用于发送消息的方法们 start---
  // 新版 sayList 组件
  const sayItemSend = sayItem => {
    console.info('>_<', sayItem);
    // file 类型比较特殊要自行组装 file 参数
    if (sayItem.file) {
      // 使用 fetch head 请求 file，从响应头的 content-length 获取文件大小
      window.fetch(sayItem.file, { method: 'HEAD' }).then(response => {
        // 从响应头的 content-length 获取文件大小
        const file_size = response.headers.get('content-length');
        // 组装 File 数组：ext, originalName, size, title, url
        const { agentId } = params;
        // 取出 ext
        const ext = HelperCore.getFileNameExt(sayItem.file);
        urlStore.newAiAgentChat(agentId, sayItem.query, {
          file: [
            {
              ext,
              size: Number(file_size) || sayItem.file_size,
              title: sayItem.file_title || sayItem.title,
              url: sayItem.file,
            },
          ],
        });
      });
    } else {
      const { agentId } = params;
      let text = sayItem.query;
      urlStore.newAiAgentChat(agentId, text);
    }
  };
  const handleSendAgent = extras => {
    let { input } = extras;
    if (isPromptTyping) {
      promptRef.current?.getPrompt();
      promptRef.current?.close();
      input = promptStrRef.current + '\n' + input;
    }
    // return console.info('>>> 发送消息', input)
    handleSend(input, extras);
  };
  const handleSend = (prompt, extras = {}) => {
    // 新建智能体会话
    // 没有安装完毕不可以发消息
    // if (!installed) return
    const { agentId } = params;
    let text = prompt;
    console.info('>>> agentId, prompt', agentId, text);
    if (!text) return;
    const isAgentFlow = isAgentFlowId(agentId);
    // 工作流，暂不支持知识库、文件
    if (isAgentFlow && !globalStore.globalConfig.supportKnowledgeWithFlow) {
      urlStore.newAiAgentChat(agentId, text);
    } else {
      urlStore.newAiAgentChat(agentId, text, {
        ...extras,
        dataset: extras.dataset,
        ...inputTypeStore.getSendParams(),
      });
    }
  };
  // 用于发送消息的方法们 end---
  const promptRef = React.useRef(null);
  const [isPromptTyping, setPromptTyping] = React.useState(false);
  const [promptsList, setPromptsList] = React.useState(null);
  const promptStrRef = React.useRef(''); // 临时存储表单值
  /** 将 prompts 同步到输入框 */
  const insertPrompts = data => {
    promptStrRef.current = data;
  };
  const openPrompts = () => {
    setPromptTyping(true);
  };
  const closePrompts = () => {
    setPromptTyping(false);
  };
  React.useEffect(() => {
    setPromptsList(agentInfo?.prompt_form || []);
    return () => {
      promptRef.current?.close();
      setPromptsList(null);
    };
  }, [agentInfo]);
  // 用于智能体表单的操作 start---

  // 智能体表单 end---

  //点击智能体进入对话页时，左侧的对话列表需要默认展开
  useEffect(() => {
    // navbarStore.setIsCollapse(true);
  }, []);

  useEffect(() => {
    return () => {
      // 关闭弹窗
      InviteCodeModal.close?.();
      store.confirmModal?.destroy?.();
    };
  }, []);

  return (
    <>
      <div className="relative h-full w-full mx-4px pt-62px">
        <div
          className={[
            'absolute top-24px flex items-center justify-center cursor-pointer size-32px',
            'hover:bg-black hover:bg-opacity-3 rounded-8px',
            navbarStore.isCollapse ? 'left-80px' : 'left-16px',
          ]}
          onClick={() => {
            if (userStore.isBrand) {
              globalStore.navigate(-1);
              return;
            }
            globalStore.navigate('/tools/aiagent');
          }}
        >
          <SVGPureIcon name="header_back_arrow" className="size-24px" />
        </div>
        {userStore.isUser && agentInfo?.creator_qid == userStore.uid ? (
          <AagentMenu
            item={agentInfo}
            deleteCallback={evt => {
              if (globalStore.isAiagentChat()) {
                globalStore.navigate(`/tools/aiagent/mine`);
                return;
              }
              globalStore.gotoAgentHome();
            }}
            className="absolute size-32px top-24px right-20px border-1px border-[rgba(0,0,0,0.1)] rounded-full overflow-hidden"
            scene="chat"
          />
        ) : null}
        {agentInfo.visitable == 1 ? (
          <div
            className={`h-62px absolute top-24px ${(userStore.isUser && agentInfo?.creator_qid) == userStore.uid ? 'right-64px' : 'right-24px'}`}
          >
            <AgentShare
              className=""
              onClick={() => {
                const copied = copy(
                  `${location.origin}/tools/aiagent/chat/${agentInfo?.id}?share=1`
                );
                copied && Other.toast('复制成功', 'success');
              }}
            />
          </div>
        ) : null}
        <ScrollView
          className={['relative', 'flex flex-col items-center justify-start']}
          style={{
            height: 'calc(100vh - 72px)', // 减去头部72px
          }}
        >
          {/* 头部自适应区域 */}
          <div className="w-full flex-1"></div>
          <div
            id="Nami_ChatAgent_Info"
            className={['w-full w-800px min-w-366px']}
          >
            <div className="mb-16px h-60px text-center">
              <img
                src={agentInfo.icon || agentInfo.images || Conf.agentIocn}
                alt=""
                className="inline-block h-60px w-60px rounded-[100%] bg-gray-50 object-cover"
              />
              {globalStore.isLimitedAgent(params?.agentId) ? (
                <div className="flex items-center justify-center relative top-[-20px]">
                  <VipTag url="https://p2.ssl.qhimg.com/t110b9a9301da99165c123c42a2.png" />{' '}
                </div>
              ) : null}
            </div>
            {installed ? (
              <div className="text-22px text-black leading-31px font-500 mt-16px mb-6px text-center fade-in">
                {agentInfo.title}
              </div>
            ) : (
              <div className="text-center mb-6px h-34px">
                <div className="inline-block h-full w-150px bg-[rgb(247,247,247)] rounded-8px"></div>
              </div>
            )}
            {installed ? (
              <div className="text-14px text-black leading-20px text-opacity-50 text-center fade-in">
                创建人：{agentInfo.creator || '纳米AI'}
              </div>
            ) : (
              <div className="text-center">
                <div className="inline-block h-20px w-100px bg-[rgb(247,247,247)] rounded-8px"></div>
              </div>
            )}
            {installed ? (
              <div className="flex flex-row flex-wrap w-full gap-10px justify-center mt-16px fade-in media-height-tag">
                {serverList.map(server => {
                  const serverName = server.display_name || server.server_name;
                  if (!serverName) return null;
                  return (
                    <div
                      key={server.display_name || server.server_name}
                      className="py-6px px-12px rounded-8px text-12px text-[rgba(0,0,0,.7)] leading-17px bg-[rgb(247,247,247)]"
                    >
                      {server.display_name || server.server_name}
                    </div>
                  );
                })}
              </div>
            ) : (
              // 骨架屏
              <div className="flex flex-row flex-wrap w-full gap-10px justify-center mt-16px media-height-tag">
                {new Array(4).fill().map((s, k) => (
                  <div
                    key={k}
                    className="w-96px h-29px rounded-8px bg-[rgb(247,247,247)]"
                  ></div>
                ))}
              </div>
            )}
            {installed ? (
              <div className="text-16px text-black leading-30px mt-16px text-center fade-in media-height-greeting">
                {agentInfo.greeting}
              </div>
            ) : (
              <div className="text-center mt-16px">
                <div className="inline-block h-30px w-460px bg-[rgb(247,247,247)] rounded-8px"></div>
              </div>
            )}
            {installed ? (
              <div
                id="Nami_ChatAgent_SayList"
                className="mt-48px media-height-example"
              >
                {saylist_example ? (
                  <SayList
                    data={store?.agentInfo?.saylist_example}
                    send={sayItemSend}
                  />
                ) : null}
              </div>
            ) : (
              <div className="mt-64px flex flex-row flex-nowrap w-full max-w-800px justify-center gap-10px">
                {new Array(5).fill().map((s, k) => (
                  <div
                    key={k}
                    className="w-148px h-170px bg-[rgb(247,247,247)] rounded-8px"
                  ></div>
                ))}
              </div>
            )}
            {!installed && (
              <div
                // className='mt-60px min-w-366px'
                className={[
                  // 'absolute bottom-[-60px] left-0',
                  'min-w-366px',
                  'mt-60px',
                  // 'transform translate-y-[100%]',
                ]}
              >
                <div className="font-600 text-16px leading-26px text-black mb-16px">
                  技能启动中...
                </div>
                <div>
                  {serverList.map(server => {
                    return (
                      <div
                        key={server.server_name}
                        className="flex flex-row items-center font-400 text-14px leading-20px text-black mb-16px"
                      >
                        {server.status === McpServerInstallStatus.installed && (
                          <SVGPureIcon
                            size={16}
                            color="#000"
                            name="icon_complete"
                            className="fade-in"
                          />
                        )}
                        {server.status ===
                          McpServerInstallStatus.unInstalled && (
                          <div className="rotate-ele">
                            <img
                              src="https://p1.ssl.qhimg.com/d/inn/8ea475776b25/nm_ag_icon_loading.png"
                              className="size-16px"
                              alt=""
                            />
                          </div>
                        )}
                        {server.status === McpServerInstallStatus.failed && (
                          <SVGPureIcon
                            size={16}
                            color="#FF3B30"
                            name="mcp_error"
                            className="fade-in"
                          />
                        )}
                        <span className="ml-6px">
                          {server.display_name || server.server_name}
                        </span>
                        {server.status < McpServerInstallStatus.installed && (
                          <span className="ml-12px text-black opacity-50">
                            启动中...
                          </span>
                        )}
                        {server.status === McpServerInstallStatus.failed &&
                          !(client.isLLQ || client.isSeLLQ) && (
                            <span className="ml-12px text-black opacity-50">
                              此MCP不支持在网页端使用
                            </span>
                          )}
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
          </div>
          {/* 底部自适应区域 */}
          <div className="w-full flex-1"></div>
          {/* 用于撑开底部区域，底部输入框和prompt区域高度*/}
          {installed && <div className="w-[100%] min-h-280px"></div>}
        </ScrollView>
        {installed && (
          <div
            id="Nami_ChatAgent_Input"
            className="z-99 absolute w-800px bottom-5px left-1/2 -translate-x-1/2 ml-[-4px] transform flex flex-col items-center fade-in bg-transparent"
            style={{
              background:
                'linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, #fff 10%)',
            }}
          >
            <PromptExample data={sayList} />
            {installed && promptsList && promptsList.length > 0 && (
              <Prompts
                ref={promptRef}
                items={promptsList}
                submit={data => insertPrompts(data)}
                open={() => {
                  appLogger.log({
                    key: 'aibot_agent',
                    action: 'click',
                    page: 'agent_chat',
                    set: 'template_button',
                  });

                  openPrompts();
                }}
                close={() => closePrompts()}
                classnames={['px-0', 'min-w-366px']}
                overrideFormClassnames={{
                  padding: '0 0',
                  // movetop: 5, // 往上位移5,
                  maxwidth: 832, // 最大宽度
                  minwidth: 366, // 最小宽度
                }}
              ></Prompts>
            )}
            <ChatInput
              isPromptTyping={isPromptTyping}
              agentInfo={agentInfo}
              handleSendAgent={handleSendAgent}
              sugStore={store}
              sug={{
                ...homeStore.curSugInfo,
                ...(sugList[homeStore.curSugInfo.category] || {}),
              }}
              placeholder={getPlaceholder || `输入想问 ${agentInfo.title} 的问题`}
              classname={['w-full max-w-800px min-w-366px bg-white']}
            />
            <div className="text-12px leading-17px text-black opacity-50 text-center mt-10px whitespace-nowrap">
              以上内容均由AI大模型生成，仅供参考
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default observer(ChatAgent);
